import React from "react";
import { Link } from "react-router-dom";

const Cta = () => {
  return (
    <div className="bg-black text-white py-10 sm:py-20 lg:py-20">
      <div className="max-w-4xl mx-auto px-6 text-center">
        
        {/* Subheading */}
        <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-gray-400 mb-6 sm:mb-8">
          Transform Today
        </p>

        {/* Main Heading */}
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-thin mb-6 sm:mb-8 leading-tight">
          Ready to Transform Your Enterprise
          <br />
          <em className="text-gray-300">with AI?</em>
        </h2>

        {/* Description */}
        <p className="text-base sm:text-md font-light leading-relaxed max-w-3xl mx-auto text-gray-300 mb-10 sm:mb-12">
          Connect with our team to explore your needs and discover how tailored
          AI solutions can accelerate innovation, strengthen operations, and
          drive measurable growth.
        </p>

        {/* CTA Button */}
        <Link to="/contact-us">
          <button className="group border border-white px-10 sm:px-12 py-3 sm:py-4 text-xs sm:text-sm tracking-[0.2em] uppercase hover:bg-white hover:text-black transition-all duration-300">
            <span className="group-hover:tracking-[0.3em] transition-all duration-300">
              Contact Us
            </span>
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Cta;
